import React, { useState, useEffect } from "react";
import { Popover, Badge, } from 'antd';
import NotificationContent from './NotificationContent'
import RequestHandler from "util/RequestHandler";
import { BellOutlined } from "@ant-design/icons";

const AppNotification = () => {
  const [notReadCount, setNotReadCount] = useState(0);
  const [visible, setVisible] = useState(0);

  useEffect(() => {
    getNotReadCount();
  }, []);

  const getNotReadCount = () => {
    RequestHandler.get(`/FeatureNotification/NotReadCount`).then((response) => {
      setNotReadCount(response);
    });
  };

  return (
    <Popover
      placement="bottomRight"
      content={<NotificationContent refreshNotReadBadge={getNotReadCount} setPopoverVisible={setVisible} />}
      trigger="click"
      onVisibleChange={(visible) => setVisible(visible)}
      visible={visible}
    >
      <Badge dot={notReadCount > 0} className="gx-mb-0">
        <span className="gx-pointer gx-d-block">
          <BellOutlined style={{ verticalAlign: "middle", lineHeight: 0, color: "white", fontSize: "20px" }} />
        </span>
      </Badge>
    </Popover>
  )
};

export default AppNotification;

